export default __webpack_public_path__ + "static/media/Medicare-Logo.8a65afe3.png";